import { Building } from '../../interfaces/api/building';
import {
	BuildingSearchFilterParam,
	getBuilding,
	getBuildings,
	getBuildingSearchFilter,
} from '../../api/buildings';

export async function fetchBuildings(): Promise<Building[]> {
	try {
		return await getBuildings();
	} catch (error) {
		throw error;
	}
}

export async function fetchBuilding(id: number): Promise<Building> {
	try {
		return await getBuilding(id);
	} catch (error) {
		throw error;
	}
}

export async function fetchBuildingsSearchFilter(
	params: BuildingSearchFilterParam
): Promise<Building[]> {
	try {
		return await getBuildingSearchFilter(params);
	} catch (error) {
		throw error;
	}
}
